export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-secondary-500 text-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="text-xl font-bold text-background-50 mb-3 block">
              快看影视
            </span>
            <p className="text-sm text-background-50/70 leading-relaxed">
              快看影视是国内领先的综艺节目免费在线观看平台，提供最新综艺、免费综艺大全高清秒播。不缓冲流畅播放，让每一帧精彩从不等待。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="space-y-2">
              {[
                { label: '最新快讯', href: '#updates' },
                { label: '综艺分类', href: '#index' },
                { label: '热门推荐', href: '#cards' },
                { label: '综艺热度榜', href: '#ranking' },
                { label: '焦点专题', href: '#carousel' },
                { label: '追综热议', href: '#comments' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollTo(link.href);
                  }}
                  className="block text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-50/50 leading-relaxed">
              内容合作与商务洽谈持续开放中，欢迎优质综艺内容方与品牌方携手共赢。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <div className="space-y-2 text-sm text-background-50/70">
              <p className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                contact@kuaikanys.com
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-wechat-line"></i>
                kuaikanys_official
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-weibo-line"></i>
                @快看影视
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-background-50/15 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/50">
            &copy; 2023-2026 快看影视 kuaikanys.com 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-background-50/50">
            <span className="cursor-pointer hover:text-background-50/80 transition-colors">隐私政策</span>
            <span className="cursor-pointer hover:text-background-50/80 transition-colors">服务条款</span>
            <span className="cursor-pointer hover:text-background-50/80 transition-colors">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}